/*
 * cpu.xhey.top session_token 存储
 *
 * 双写：内存（同 tab 内 sync）+ localStorage（刷新 / 多 tab 兜底）。
 * 单 token 模式：同时只缓存一条 token，绑定一个 groupId。group 切换时整条丢弃。
 */

const STORAGE_KEY = 'aiClerk:cpuSessionToken'

export interface CachedToken {
  /** Bearer token */
  token: string
  /** 过期绝对时间戳（ms） */
  expiresAt: number
  /** 这条 token 绑定的 groupId（切了 group 就要换） */
  groupId: string
  /** 这条 token 绑定的 userId（不同账号也要换） */
  userId: string
}

let memCache: CachedToken | null = null

function readStorage(): CachedToken | null {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as CachedToken
    if (
      parsed &&
      typeof parsed.token === 'string' &&
      typeof parsed.expiresAt === 'number'
    ) {
      return parsed
    }
  } catch {
    /* no-op */
  }
  return null
}

function writeStorage(t: CachedToken | null) {
  try {
    if (t) {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(t))
    } else {
      window.localStorage.removeItem(STORAGE_KEY)
    }
  } catch {
    /* no-op */
  }
}

export const tokenStore = {
  get(): CachedToken | null {
    if (memCache) return memCache
    const fromStorage = readStorage()
    if (fromStorage) memCache = fromStorage
    return memCache
  },

  set(t: CachedToken): void {
    memCache = t
    writeStorage(t)
  },

  clear(): void {
    memCache = null
    writeStorage(null)
  },

  /** 当前缓存的 token 是否已过期（含 0 容忍）*/
  isExpired(now: number = Date.now()): boolean {
    const t = this.get()
    if (!t) return true
    return t.expiresAt <= now
  },

  /** 是否需要主动续签（剩 < 1 天）*/
  needsRefresh(now: number = Date.now()): boolean {
    const t = this.get()
    if (!t) return true
    const ONE_DAY_MS = 24 * 60 * 60 * 1000
    return t.expiresAt - now < ONE_DAY_MS
  }
}
